import * as Yup from 'yup';

export const validate = Yup.object().shape({
  physician_phone: Yup.string().matches(
    /^.{5,}[0-9]+$|^$/,
    'Please enter valid phone number',
  ),
});
